import React from 'react'
import Content from '../Content/Content'
import { style } from './Index.style'
import SectionTitle from '../SectionTitle/SectioinTitle'
import NewsList from './NewsList'
import Footer from './Footer'

const Report = () => {
  return (
    <section id="report_section" css={style.section}>
      <Content>
        <SectionTitle sectionSubTitle="REPORT" sectionTitle="活動報告" />
        <NewsList subcategory="report" />
        <Footer subcategory="report" />
      </Content>
    </section>
  )
}

export default Report
